import { Flex, Text, Button, Link } from "@wayflyer/flyui";
import { IconArrowRight24Line } from "@wayflyer/flyui-icons/24/line";
import { useIntl } from "react-intl";
import { useSearchParams } from "react-router-dom";

import { MESSAGES } from "./message-definitions";

type GetStartedSectionProps = {
  isMobile: boolean;
  cobrandingPartnerName?: string;
};

export const GetStartedSection = ({ isMobile, cobrandingPartnerName }: GetStartedSectionProps) => {
  const { formatMessage } = useIntl();
  const [searchParams] = useSearchParams();
  const firstName = searchParams.get("first_name");
  const searchParamPartnerName = searchParams.get("partner_name");
  const partnerName = cobrandingPartnerName || searchParamPartnerName;

  const {
    getStartedGreetingMessage,
    getStartedDescription,
    getStartedButton,
    getStartedAlreadyHaveAnAccount,
    getStartedNavigateToLogInPageLink,
  } = MESSAGES;

  const proceedToApplication = () => {
    const params = new URLSearchParams(location.search);
    params.delete("step");
    params.delete("animate");
    const search = params.toString();
    window.location.href = search.length > 0 ? `/authn/signup?${search}` : "/authn/signup";
  };

  return (
    <Flex direction="column" gap={isMobile ? "6" : "10"}>
      <Flex direction="column" justify="center" align={isMobile ? "flex-start" : "center"}>
        <Text lineHeight="tight" size="5xl" fontWeight="semiBold">
          {formatMessage(getStartedGreetingMessage, { firstName: firstName ? ` ${firstName}` : "" })}
        </Text>
        {partnerName && (
          <Text size="base" fontWeight="regular" fontStyle="regular">
            {formatMessage(getStartedDescription, { partnerName })}
          </Text>
        )}
      </Flex>
      <Flex direction="column" gap="4" justify="center" align={isMobile ? "flex-start" : "center"}>
        <Button variant="Primary" iconRight={IconArrowRight24Line} onClick={proceedToApplication}>
          {formatMessage(getStartedButton)}
        </Button>
        <Text size="base" fontWeight="regular" fontStyle="regular">
          {formatMessage(getStartedAlreadyHaveAnAccount)}{" "}
          <Link url={window.location.origin} accessibilityLabel="Navigate to Log in page">
            {formatMessage(getStartedNavigateToLogInPageLink)}
          </Link>
        </Text>
      </Flex>
    </Flex>
  );
};
